import { pathToUrl } from '../../helpers/urls';

import { Species } from './getSpeciesAtLocation';

interface Result {
  success: boolean;
  results: Species[];
  message?: string;
}

export async function getSpeciesById(
  { fishrulesSpeciesId }: { fishrulesSpeciesId: number },
  signal: AbortSignal,
): Promise<Result> {
  const response = await fetch(pathToUrl('/api/_fishrules/get-species-by-id'), {
    body: JSON.stringify({ fishrulesSpeciesId }),
    method: 'POST',
    signal,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
  });
  const json: Result = await response.json();
  return json;
}
